import { Box, PageHeader } from '@chatsdet/ui';
import { useAuth } from '../../../../contexts/AuthContext';
import { EnvironmentVariablesSection } from './EnvironmentVariablesSection';
import { ReleaseQASection } from './ReleaseQASection';
import { SessionStateSection } from './SessionStateSection';

/**
 * Advanced application settings: the infrastructure a test run depends on.
 * Each section owns its own fields and saves independently — the update route
 * treats omitted keys as "leave unchanged".
 */
export function PropertyAdvancedTab({ propertyId }: { propertyId: string }) {
  const { user } = useAuth();

  return (
    <Box className="space-y-4">
      <PageHeader
        size="section"
        title="Advanced"
        description="How this application is wired up for automated testing."
      />
      <SessionStateSection propertyId={propertyId} />
      <EnvironmentVariablesSection propertyId={propertyId} />
      {user?.features?.releaseQa && <ReleaseQASection propertyId={propertyId} />}
    </Box>
  );
}
